import { render, staticRenderFns } from "./RegistrationData.vue?vue&type=template&id=0decc5da&scoped=true&"
import script from "./RegistrationData.vue?vue&type=script&lang=js&"
export * from "./RegistrationData.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationData.vue?vue&type=style&index=0&id=0decc5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0decc5da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0decc5da')) {
      api.createRecord('0decc5da', component.options)
    } else {
      api.reload('0decc5da', component.options)
    }
    module.hot.accept("./RegistrationData.vue?vue&type=template&id=0decc5da&scoped=true&", function () {
      api.rerender('0decc5da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/RegistrationData.vue"
export default component.exports